import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-marketing-data-by-user',
  templateUrl: './marketing-data-by-user.component.html',
  styleUrls: ['./marketing-data-by-user.component.css']
})
export class MarketingDataByUserComponent implements OnInit {
  marketingData: any= []
  singleMarketingData: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  buttondisable = false
  TypeData:any = []
  tagUsersdropdownList  = [];
  tagUsersselectedItems:any = [];
  filterBy: any = ""
  usersList: any= []
  statusList: any=[]
  latestStatus = ""
  toggleStatus = false;
  marketingId = 0;
  labels:any = [];
  updateMarketingStatus: any | FormGroup
  updateMarketingForm: any | FormGroup;
  searchInputType:any = ""
  searchInput:any = "";
  searchInputPlaceholder = "";

  userId:any = ""
  searchDate:any = "";
  usersData:any = [];
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllStatus()
    this.getallUsers()
    this.cid = sessionStorage.getItem('cid')
    this.updateMarketingForm = this.fb.group({
      status: [''],
      note: ['']
    }) 

    this.updateMarketingStatus = this.fb.group({
      status: [''],
      note: ['']
    }) 
  }

  getAllStatus(){
    this.generic_service.getAllStatusMaster().subscribe(
      (res:any)=>{
        console.log(res)
        this.statusList = res.response;
      }
    )
  }

  getallUsers(){
    this.generic_service.getUsers().subscribe(
      (response:any)=>{
        let arr = []
        for(var i=0; i<response.response.length; i++){
          if(response.response[i].userType.toLowerCase() != 'su'){
            console.log(response.response[i].userType.toLowerCase())
            arr.push(response.response[i])
          }
        }
        this.usersData = arr;
        console.log(response)
      }
    )
  }

  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
        this.tagUsersdropdownList = res.response;
      }
    )
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  onTableDataChange(event: any) {
    this.page = event;
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
  }

  getMarketingData(){
    this.generic_service.getMarketingData().subscribe(
      (response:any)=>{
        console.log(response)
        this.marketingData = response.response
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getMarketingDataById(id:any){
    this.marketingId = Number(id);
    this.generic_service.getMarketingDataById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.singleMarketingData = []
        this.latestStatus = response.response.latestStatus
        this.singleMarketingData.push(response.response);
        document.getElementById("template-view")?.click()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  searchSelect(event:any){
    console.log(event.target.value)
    this.searchInputType = String(event.target.value);
    this.searchInput = ""
    this.searchInputPlaceholder = "Search By " + event.target.value;
    console.log(this.searchInputPlaceholder)
  }

  searchFilter(){
    let data = new Date(this.searchDate).getTime();
    if(this.userId == "" || this.searchDate == ""){
      if(this.userId != "" && this.searchDate == ""){
        this.toastr.error('select user')
      }
      if(this.userId == "" && this.searchDate != ""){
        this.toastr.error('select date')
      }
      if(this.userId == "" && this.searchDate == ""){
        this.toastr.error('select user and date')
      }
      return;
    }else{
      this.generic_service.getMarketingDataByUserIdAndDate(this.userId,data).subscribe(
        (response:any) =>{
          console.log(response)
          this.marketingData = response.response
        },
        (error:any) =>
        console.log(error)
      )
      
      // if(this.searchInputType == "Phone"){
      //   this.generic_service.getMarketingDataByPhone(this.searchInput).subscribe(
      //     (response:any) =>{
      //       console.log(response)
      //       this.marketingData = response.response
      //     }
      //   )
      // }

      // if(this.searchInputType == "Name"){
      //   this.generic_service.getMarketingDataByName(this.searchInput).subscribe(
      //     (response:any) =>{
      //       console.log(response)
      //       this.marketingData = response.response
      //     }
      //   )
      // }

      // if(this.searchInputType == "Email"){
      //   this.generic_service.getMarketingDataByEmail(this.searchInput).subscribe(
      //     (response:any) =>{
      //       console.log(response)
      //       this.marketingData = response.response
      //     }
      //   )
      // }

      // if(this.searchInputType == "Status"){
      //   this.generic_service.getMarketingDataByLatestStatus(this.searchInput).subscribe(
      //     (response:any) =>{
      //       console.log(response)
      //       this.marketingData = response.response
      //     }
      //   )
      // }
    }
  }

  showStatus(){
    this.toggleStatus = true;
  }

  updateStatusClose(){
    this.toggleStatus = false;
  }

  updateMarketingData(){

    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.singleMarketingData[0].description),
      "id": Number(this.singleMarketingData[0].id),
      "name": String(this.singleMarketingData[0].name),
      "phone": String(this.singleMarketingData[0].phone),
      "email": String(this.singleMarketingData[0].email),
      "keyValueList": this.singleMarketingData[0].keyValueList,
      "marketingStatusList": this.singleMarketingData[0].marketingStatusList,
      "latestStatus": String(this.singleMarketingData[0].latestStatus),
      "latestStatusUserId": String(this.singleMarketingData[0].latestStatusUserId),
      "tagUserList": this.singleMarketingData[0].tagUserList,
      "assignedToUser": Number(this.singleMarketingData[0].assignedToUser),
      "serialNo": Number(this.singleMarketingData[0].serialNo),
      "cid": Number(this.singleMarketingData[0].cid),
      "createdDate":Number(this.singleMarketingData[0].createdDate),
    }
    console.log(body)
    console.log(this.singleMarketingData)

    this.generic_service.updateMarketingData(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.toastr.success(response.message)
        this.getMarketingDataById(this.marketingId)
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.error[0].description)
      }
    )
  }

  updateStatus(){
    let body = {
      "status": String(this.updateMarketingStatus.get('status').value),
      "userId": String(sessionStorage.getItem('userId')),
      "note": String(this.updateMarketingStatus.get('note').value),
    }
    console.log(body);

    this.generic_service.updateMarketingDataStatus(body,this.marketingId).subscribe(
      (response:any)=>{
        console.log(response);
        this.toggleStatus = false;
        this.updateMarketingStatus.reset();
        this.getMarketingDataById(this.marketingId)
        document.getElementById("updateClose")?.click()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }
}